import { defaultParamsSerializer, handleApiResponse, notifyInternalMessage } from '@/functions';
import { IFetchDataParams, IPaymentMethodRequest } from '@/interfaces';
import { PaymentMethodRequestStatusEnum } from '@/enums';
import { useQuery } from '@tanstack/react-query';
import { apiClient } from '@/components/api';
import { Paginated } from '@/lib/interface';
import routes from '@/lib/routes';
import dayjs from 'dayjs';

type TResponseData = Paginated<IPaymentMethodRequest>;
type TParams = IFetchDataParams & {
  status?: PaymentMethodRequestStatusEnum;
  country?: string;
};

const VARIABLES = {
  convertResponseData: (responseData?: TResponseData) => {

    if (!responseData) {
      return responseData;
    }

    return {
      ...responseData,
      data: (
        [...(responseData?.data ?? [])]
          .map(l => ({ ...l, createdAt: dayjs(l.createdAt).toDate() }))
      )
    };

  },
  defaultData: {
    data: [],
    pagination: {
      hasPreviousPage: false,
      hasNextPage: false,
      itemCount: 0,
      pageCount: 0,
      limit: 20,
      page: 1
    }
  } as TResponseData
};

export const useRequestGetPaymentMethodRequests = (params?: TParams) => {

  const { isFetching, data, error } = useQuery({
    queryKey: [routes.api.paymentMethodRequests, params],
    queryFn: () => apiClient
      .get<TResponseData>(
        routes.api.paymentMethodRequests,
        params,
        { paramsSerializer: defaultParamsSerializer }
      )
      .then(handleApiResponse)
      .then(VARIABLES.convertResponseData)
      .catch(notifyInternalMessage)
  });

  const dataResult = data ?? VARIABLES.defaultData;
  const paymentMethodRequests = dataResult.data ?? [];

  return ({
    isLoading: isFetching,
    data: dataResult,
    paymentMethodRequests,
    error
  });

};
